import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubTab from './../SubTab/SubTab';
import './SMECenterSupport.scss';

const SMECenterSupport = () => {
  const category = 'SMECenterSupport';
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (num) => setSelect((prev) => (prev === num ? 0 : num));
  const movePage = (path) => navigate(path);

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}기업 지원 사업
            </div>
            <div className="banner_main_text">기업 지원 사업</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업지원사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>

            <div className="navi_box enterprise" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">중소기업지원센터지원 사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  충남지역혁신프로젝트 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationCluster')}>
                  충남지역혁신클러스터
                </div>
                <div className="select_row" onClick={() => movePage('/business/carbonNeutralInfrastructure')}>
                  탄소중립실증인프라구축사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/EnergyGrowthSupport')}>
                  에너지 동반성장 상생혁력지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/LocalYouthJob')}>
                  충남 지역주도형 청년일자리지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthJobIncentive')}>
                  청년일자리 도약장려금지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/SMECenterSupport')}>
                  중소기업지원센터지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/DormLeaseSupport')}>
                  산업단지 기숙사 임차지원 사업
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sub_main_area temporary">
          <SubTab category={category} />

          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">SME Center Support</p>
              <h2 className="business-hero-title">중소기업지원센터 지원사업</h2>
              <p className="business-hero-period">사업기간 : 2026. 3. 1. ~ 2026. 12. 31.</p>
            </div>
          </div>

          <div className="sub_main_back">
            <div className="vision_container">
              <section className="smeCS">
                {/* 사업목적 */}
                <div className="vision_title_box nonline">
                  <div className="logo_box">
                    <div className="logo_img"></div>
                  </div>
                  <div className="title_text">사업목적</div>
                </div>
                <div className="smeCS__paper">
                  <ul className="smeCS__bullet">
                    <li>국내·외 인증 획득 지원을 통한 지역 중소기업 경쟁력 강화 도모</li>
                    <li>
                      당진 지역 중소기업 재직자 기술 역량 강화를 위한 맞춤형 교육 제공 및 우수 인재 육성을 통한 지역정착
                      기여
                    </li>
                  </ul>
                </div>
                {/* 사업내용 및 성과 */}
                <div className="vision_title_box nonline">
                  <div className="logo_box">
                    <div className="logo_img"></div>
                  </div>
                  <div className="title_text">사업내용 및 성과</div>
                </div>
                <div className="smeCS__paper">
                  <table className="smeCS__table">
                    <thead>
                      <tr>
                        <th style={{ width: '35%' }}>구분</th>
                        <th>내용</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="smeCS__tdStrong">국내·외 인증 획득 지원</td>
                        <td>당진 관내 중소기업 대상 국내·외 인증 획득 지원 18개사</td>
                      </tr>
                      <tr>
                        <td className="smeCS__tdStrong">재직자 맞춤형 교육 지원</td>
                        <td>당진 관내 중소기업 대상 재직자 교육 지원 120명</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* 사업 추진체계(프로세스) */}
                <div className="vision_title_box nonline">
                  <div className="logo_box">
                    <div className="logo_img"></div>
                  </div>
                  <div className="title_text">사업 추진체계</div>
                </div>
                <div className="smeCS__flowWrap">
                  {/* Flow 1 */}
                  <div className="smeCS__flowBlock">
                    <div className="smeCS__flowHead">
                      <div className="smeCS__flowTitle">국내·외 인증 획득 지원</div>
                    </div>

                    <div className="smeCS__flowGrid is-6">
                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">①</div>
                        <div className="smeCS__stepTitle">사업공고</div>
                        <div className="smeCS__stepLines">- 사업 홍보</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">②</div>
                        <div className="smeCS__stepTitle">참여신청 및 평가</div>
                        <div className="smeCS__stepLines">
                          - 참여기업신청 접수
                          <br />- 신청기업 평가
                        </div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">③</div>
                        <div className="smeCS__stepTitle">수혜기업 선정</div>
                        <div className="smeCS__stepLines">- 수혜기업 선정 및 협약체결</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">④</div>
                        <div className="smeCS__stepTitle">경영진단 및 컨설팅</div>
                        <div className="smeCS__stepLines">- 기업맞춤형 컨설팅</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">⑤</div>
                        <div className="smeCS__stepTitle">인증 심사 및 획득</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">⑥</div>
                        <div className="smeCS__stepTitle">최종완료평가 및 지원금지급</div>
                      </div>
                    </div>
                  </div>

                  {/* Flow 2 */}
                  <div className="smeCS__flowBlock">
                    <div className="smeCS__flowHead">
                      <div className="smeCS__flowTitle">재직자 맞춤형 교육 지원</div>
                    </div>

                    <div className="smeCS__flowGrid is-5">
                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">①</div>
                        <div className="smeCS__stepTitle">참여기업 신청 접수</div>
                        <div className="smeCS__stepLines">(기업 → 운영기관)</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">②</div>
                        <div className="smeCS__stepTitle">참여기업 요건 검토</div>
                        <div className="smeCS__stepLines">(운영기관 → 기업)</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">③</div>
                        <div className="smeCS__stepTitle">교육일정 수립</div>
                        <div className="smeCS__stepLines">(운영기관)</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">④</div>
                        <div className="smeCS__stepTitle">교육 운영</div>
                        <div className="smeCS__stepLines">(운영기관 → 재직자)</div>
                      </div>

                      <div className="smeCS__step">
                        <div className="smeCS__stepNo">⑤</div>
                        <div className="smeCS__stepTitle">사후 관리</div>
                        <div className="smeCS__stepLines">(운영기관 → 기업)</div>
                      </div>
                    </div>
                  </div>
                </div>
                <br /> <br /> <br />
              </section>
              {/* ===================== /사업내용 ===================== */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMECenterSupport;
